import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { translate } from '../../Services/translation';
import BuyButton from '../BuyButton/BuyButton';
import VariantMultiPickerDropdown from '../VariantPicker/VariantMultiPicker.Dropdown';
import VariantPickerDropdown from '../VariantPicker/VariantPicker.Dropdown';
import { useDispatch } from 'react-redux';
import { setBuyButtonArticleNumber, setBuyButtonStockStatuses, setBuyButtonStockStatus } from '../../Actions/BuyButton.action';
import BackInStockdModal from '../BackInStock/BackInStockModal';
import BackInStockButton from '../BackInStock/BackInStockButton';
import ExpressCheckoutButton from '../ExpressCheckout/ExpressCheckoutButton';
import { get } from '../../Services/http';
import { updateSelectedVariant } from '../../Actions/SelectedVariant.action';

const StyledVariantSelectBuyButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const VariantSelectBuyButtonContainer = ({
  product,
  isCategoryPage,
  hideText,
  dropDownSize,
  isVariantListing,
  personalDataPagePointer,
  clickSource
}) => {
  const GetInitialVariant = () => {

    const currentSize = new URLSearchParams(window.location.search).get('variantSize');
    const currentReduxSize = useTypedSelector(state => state.SelectedVariant.size);
    const sizeToUse = currentSize || currentReduxSize;

    if (sizeToUse) {
      const matchedOption = product.variantPickerOptions.options.find(
        (x) => x.firstVariantValue.toLowerCase() === sizeToUse.toLowerCase()
      );
      if (matchedOption) return matchedOption.variantId;
    }

    return product.id;
    // if (product.hasQueryVariant) {
    //   return product.id;
    // }
    // return '';
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [variantPickerOptions, setVariantPickerOptions] = useState(product.variantPickerOptions);
  const [expressCheckoutEnabled, setExpressCheckoutEnabled] = useState(false);

  useEffect(() => {
    get('/api/client-context/product/' + product.id)
      .then(res => res.json())
      .then((data) => {
        setVariantPickerOptions(data.variantPickerOptions);
        setExpressCheckoutEnabled(data.expressCheckoutEnabled);
        dispatch(setBuyButtonStockStatuses(data.stockStatuses));
        dispatch(setBuyButtonStockStatus(data.stockStatus));
      });
  }, [product.variantPickerOptions]);

  const handleButtonClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const CheckIfVariantIsInStock = () => {
    const options = variantPickerOptions?.options;
    if (options && Array.isArray(options)) {
      const matchingVariant = options.find(
        (x) => x?.variantId === selectedVariantId && x?.inStock
      );
      return matchingVariant ? true : false;
    }
    return product?.stockStatus?.inStock || false;
  };

  const GetSize = () => {
    const options = variantPickerOptions?.options;
    if (options && Array.isArray(options)) {
      const matchingVariant = options.find(
        (x) => x?.variantId === selectedVariantId
      );
      if (matchingVariant) {
        const { firstVariantValue, secondVariantValue } = matchingVariant;
        return (firstVariantValue ?? '') + (secondVariantValue ?? '');
      }
    }
    return '';
  };

  let dispatch = useDispatch();
  const [selectedVariantId, setSelectedVariantId] = useState(
    GetInitialVariant()
  );

  useEffect(() => {
    if (selectedVariantId) {
      dispatch(setBuyButtonArticleNumber(selectedVariantId));
    }
  }, [selectedVariantId])

  const [inStock, setInStock] = useState(CheckIfVariantIsInStock());
  const [size, setSize] = useState(GetSize());
  const userInfo = useTypedSelector((state) => state.userInfo);
  const isBusinessCustomer = userInfo?.current?.isBusinessCustomer;

  const onChange = (event) => {
    setSelectedVariantId(event.variantId);
    setInStock(event.inStock);
    setSize(event.firstVariantValue);
    if (event.articleNumber && !isCategoryPage) {
      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        `?variant=${event.articleNumber}`;
      window.history.pushState({ path: newurl }, '', newurl);
    }
    dispatch(updateSelectedVariant(event.label, event.value))
  };

  const GetLayout = (product, isBusinessCustomer, isCategoryPage) => {
    if (/*isBusinessCustomer != true &&*/ isCategoryPage) {
      return (
        <button
          className="btn btn--outline-black btn--medium font-satoshi-bold"
          onClick={() => (window.location.href = product.url)}
        >
          {translate('buy-button.go-to-product')}
        </button>
      );
    } else if (
      variantPickerOptions?.firstVariant != null &&
      variantPickerOptions?.secondVariant != null
    ) {
      return (
        <>
          <VariantMultiPickerDropdown
            {...variantPickerOptions}
            setSelectedArticleNumber={onChange}
            dropDownSize={dropDownSize}
            isBackOrder={product.isBackOrder}
            selectedVariantId={selectedVariantId}
            setIsModalOpen={handleButtonClick}
          />
          {inStock ||
            selectedVariantId === '' ||
            selectedVariantId === undefined ? (
            <>
              <BuyButton
                hideText={hideText}
                articleNumber={selectedVariantId}
                expressCheckoutEnabled={expressCheckoutEnabled}
                clickSource={clickSource}
              />
            </>
          ) : (
            <>
              <BackInStockButton onButtonClick={handleButtonClick} />
              <BackInStockdModal
                productId={
                  selectedVariantId !== '' ? selectedVariantId : product.id
                }
                size={size}
                personalDataPagePointer={personalDataPagePointer}
                isModalOpen={isModalOpen}
                onButtonClick={handleButtonClick}
              />
            </>
          )}
        </>
      );
    } else if (
      variantPickerOptions?.firstVariant != null &&
      variantPickerOptions?.secondVariant == null
    ) {
      return (
        <>
          <VariantPickerDropdown
            {...variantPickerOptions}
            setSelectedArticleNumber={onChange}
            dropDownSize={dropDownSize}
            isBackOrder={product.isBackOrder}
            selectedVariantId={selectedVariantId}
            setIsModalOpen={handleButtonClick}
          />
          {inStock ||
            selectedVariantId === '' ||
            selectedVariantId === undefined ? (
            <>
              <BuyButton
                hideText={hideText}
                articleNumber={selectedVariantId}
                expressCheckoutEnabled={product.expressCheckoutEnabled}
                clickSource={clickSource}
              />
            </>
          ) : (
            <>
              <BackInStockButton onButtonClick={handleButtonClick} />
              <BackInStockdModal
                productId={
                  selectedVariantId !== '' ? selectedVariantId : product.id
                }
                size={size}
                personalDataPagePointer={personalDataPagePointer}
                isModalOpen={isModalOpen}
                onButtonClick={handleButtonClick}
              />
            </>
          )}
        </>
      );
    } else {
      return (
        <>
          {inStock ? (
            <>
              <BuyButton
                hideText={hideText}
                articleNumber={product.id}
                expressCheckoutEnabled={product.expressCheckoutEnabled}
                clickSource={clickSource}
              />
            </>
          ) : (
            <>
              <BackInStockButton onButtonClick={handleButtonClick} />
              <BackInStockdModal
                productId={
                  selectedVariantId !== '' ? selectedVariantId : product.id
                }
                size={size}
                personalDataPagePointer={personalDataPagePointer}
                isModalOpen={isModalOpen}
                onButtonClick={handleButtonClick}
              />
            </>
          )}
        </>
      );
    }
  };

  return (
    <>
      <StyledVariantSelectBuyButtonContainer>
        {GetLayout(product, isBusinessCustomer, isCategoryPage)}
      </StyledVariantSelectBuyButtonContainer>
    </>
  );
};

export default VariantSelectBuyButtonContainer;
